<template>
  <section>
    <HeaderSection :title="post.title" />
    <div class="container py-6">
      <img v-if="post.cover" :src="post.cover.versions.hd" />
      <h2
        class="mt-3 text-3xl font-bold text-black uppercase text-start"
        v-text="post.title"
      />

      <div class="mt-3 text-base text-gray-500" v-text="post.published_at" />

      <!-- eslint-disable-next-line-->
      <!-- <iframe
        id="news-details"
        class="w-full h-full mt-3 static-page"
        :srcdoc="post.content"
      /> -->
      <NewsDetailsContent :content="post.content" />

      <div v-if="post.tags.length > 0" class="mt-3 space-s-3">
        <span
          v-for="(tag, tagIndex) in post.tags"
          :key="tagIndex"
          class="px-2 py-1 text-xs uppercase bg-gray-100 rounded-md shadow-md"
          v-text="tag"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import { useTranslation } from "i18next-vue";
const route = useRoute();
const $config = useRuntimeConfig().public;
const router = useRouter();
const nuxtApp = useNuxtApp();
const { t } = useTranslation();

const postSeoData = ref(null);
const post = ref(null);

try {
  const slug = route.params.slug_id;
  const { data, error } = await useAPI(`api/front/posts/slug/${slug}`);
  if (data._rawValue) {
    post.value = data._rawValue.data;
    postSeoData.value = data._rawValue.data.seo;
  } else if (error.value) {
    throw createError({
      statusCode: 404,
      statusMessage: "Page Not Found",
      fatal: true,
    });
  }
} catch (e) {
  throw createError({
    statusCode: 404,
    statusMessage: "Page Not Found",
    fatal: true,
  });
}

onMounted(() => {});

useSchemaOrg([
  {
    "@type": "Article",
    "@id": $config.APP_URL + router.currentRoute._rawValue.fullPath,
    headline: post.value.title,
    url: $config.APP_URL + router.currentRoute._rawValue.fullPath,
    image: post.value.cover && post.value.cover.versions.hd,
    description: post.value.excerpt,
    datePublished: post.value.published_at,
  },
]);

let seoData = {
  page_title: post.value.title,
  meta_name: post.value.title,
  meta_description: post.value.title,
  model_id: route.params.slug_id,
  model_type: "Post",
  og_name: post.value.title,
  og_description: post.value.excerpt,
  og_image: post.value.cover && post.value.cover.versions.hd,
};

if (postSeoData.value) {
  seoData = {
    ...seoData,
    ...postSeoData.value,
  };
}

nuxtApp.$seoModule(seoData);
</script>

<style>
@media only screen and (max-width: 767px) {
  .static-page iframe {
    width: 100% !important;
  }

  .static-page img {
    width: 100% !important;
    margin: 0px !important;
    padding: 5px !important;
  }
}
</style>
